<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
    <app-articles-view
      [articles]="alumniArticles"
      [itemsPerPage]="limit"
      [totalcount] ="totalcount"
      (onPaginateEvent) = "onPaginateEvent($event)"
    ></app-articles-view>
  </div>
</div>
